import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AvailableOn from "../AvailableOn/AvailableOn";
import "./OrderPlaced.css";

function OrderPlaced() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="order-placed-page">
      <section className="section-header-title navigation-space-mob order-placed-hero">
        <div className="order-placed-container">
          <h1>Order Placed</h1>
        </div>
      </section>
      <img
        src="/Image/border-bottom-title.png"
        className="w-full header-title-image"
        alt=""
      />

      <section className="order-placed-section">
        <div className="order-placed-container">
          <div className="order-placed-card">
            <div className="order-placed-content">
              <img
                src="/kuku-assets/images/check-mark.gif"
                className="order-placed-success-gif"
                alt="Order placed successfully"
              />
              <h2>Thank you for Purchase</h2>
              <Link to="/" className="order-placed-button">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>

      <AvailableOn />
    </main>
  );
}

export default OrderPlaced;